import variables from './variables'

export default {
  colors: {
    buttons: {
      primaryBackground: variables.colors.extendGreen,
      secondaryText: variables.colors.extendGreen,
      secondaryOutline: variables.colors.extendGreen,
    },
  },
  anchorNavigation: {
    borderBottomStyle: 'none',
    borderBottomColor: 'none',
    borderBottomWidth: 'none',
    boxShadow: `0px 0px 10px ${variables.colors.gray300}`,
  },
}
